import api from './api';

export function getAdoCode(idCredit) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${idCredit}/ado/last-transaction`)
}

export function validateAdoCode(origen, codigoAdo, idNumberCliente, idCredit, subCanal) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/ado/${origen}/${codigoAdo}/${idNumberCliente}/${idCredit}/${subCanal}/validate`)
}
